import React from 'react';

const PrincipalMessage = () => {
  return (
    <section id="principal" className="bg-white py-6 md:py-8">
      <div className="max-w-5xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-8 items-center">
          
          {/* Principal Image Section */}
          <div className="text-center lg:text-left">
            <div className="relative inline-block">
              <img 
                src="/assets/principal-image.jpeg" 
                alt="Syed Muhammad Ilyas - Regional Head" 
                className="w-full max-w-md mx-auto lg:mx-0 h-80 sm:h-96 object-cover object-center rounded-lg shadow-lg"
              />
            </div>
            {/* <div className="mt-4">
              <h3 className="text-lg font-bold text-black mb-1">Syed Muhammad Ilyas</h3>
              <p className="text-gray-600 text-sm">Regional Head</p>
            </div> */}
          </div>
          
          {/* Message Content Section */}
          <div className="space-y-4">
            {/* Header */}
            <div>
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-black mb-2">
                Welcome To PAK School & College Mardan!
              </h2>
              <div className="w-10 h-0.5 bg-black mb-3"></div>
            </div>
            
            {/* Message Content */}
            <div className="space-y-3 text-gray-700 leading-relaxed">
              <p className="text-xs sm:text-sm">
                Our community is dedicated to academic excellence, personal growth, and the pursuit of knowledge. 
                We prioritize student-centered learning, fostering an environment that encourages 21st century 
                skills like curiosity, critical thinking, and collaboration.
              </p>
              
              <p className="text-xs sm:text-sm">
                Our team of educators is committed to providing a supportive and inclusive atmosphere where 
                each student can reach their full potential. Through innovative teaching methods and a 
                comprehensive curriculum, we prepare our students for success in an ever-evolving world.
              </p>
              
              <p className="text-xs sm:text-sm">
                Visit our website to learn more about our programs and opportunities. Let's inspire a passion 
                for learning, cultivate resilience, and empower students on their journey of lifelong achievement.
              </p>
            </div>
            
            {/* Signature */}
            <div className="bg-gray-50 p-3 rounded-lg">
              <div className="text-center">
                <p className="text-gray-600 mb-1 text-xs">Regards,</p>
                <h3 className="text-sm font-bold text-black mb-1">Syed Muhammad Ilyas</h3>
                <p className="text-gray-600 text-xs">Regional Head</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrincipalMessage;
